import React from "react";
import "./Departments.css";

const GraminPaniPuravathaVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>ग्रामीण पाणी पुरवठा बांधकाम विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          💧
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            ग्रामीण पाणी पुरवठा बांधकाम विभाग
          </h1>

          <div className="dept-header-subtitle">
            जल जीवन मिशन व ग्रामीण पाणीपुरवठा योजना
          </div>

        </div>

        <div className="dept-header-badge">
          WATER SUPPLY DEPARTMENT
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          जल जीवन मिशन
        </button>

        <button className="dept-nav-tab">
          योजना
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* INTRO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            सुरक्षित पिण्याचे पाणी प्रत्येक घरापर्यंत
          </div>

          <p className="dept-intro-text">
            <strong>ग्रामीण पाणी पुरवठा बांधकाम विभाग</strong>
            हा ग्रामीण भागातील सुरक्षित व शाश्वत
            पिण्याच्या पाण्याचा पुरवठा सुनिश्चित करण्यासाठी
            कार्यरत आहे. सन 2019-2020 पासून विविध
            ग्रामीण पाणीपुरवठा योजनांचे रुपांतर
            <strong> जल जीवन मिशन (JJM) </strong>
            अंतर्गत करण्यात आले असून प्रत्येक ग्रामीण
            घराला कार्यक्षम नळ जल जोडणी उपलब्ध
            करून देणे हे प्रमुख उद्दिष्ट आहे.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">55 LPCD</div>
            <div className="dept-stat-label">
              प्रतिदिन पाणी पुरवठा उद्दिष्ट
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">2024</div>
            <div className="dept-stat-label">
              FHTC उद्दिष्ट वर्ष
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">100%</div>
            <div className="dept-stat-label">
              घरगुती नळ जोडणी
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">50:50</div>
            <div className="dept-stat-label">
              केंद्र व राज्य निधी
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* WATER SUPPLY SCHEMES */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🚰
              </div>

              <h2 className="dept-section-title">
                पाणी पुरवठा योजना
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">
                <div className="scheme-card-name">
                  साधी विहीर
                </div>

                <div className="scheme-card-desc">
                  ग्रामीण भागासाठी मूलभूत पाणीपुरवठा
                  सुविधा निर्माण करणे.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  विहीर रुंदीकरण व खोलीकरण
                </div>

                <div className="scheme-card-desc">
                  अस्तित्वातील विहिरींची क्षमता वाढविणे
                  व जलसाठा मजबूत करणे.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  विंधन विहीर (हातपंप)
                </div>

                <div className="scheme-card-desc">
                  भूजल उपलब्धतेनुसार हातपंप
                  व विंधन विहिरीची उभारणी.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  लघु नळ पाणी पुरवठा योजना
                </div>

                <div className="scheme-card-desc">
                  गावस्तरावर नळाद्वारे पाणी
                  पुरवठा व्यवस्था निर्माण करणे.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  शिवकालीन पाणी साठवण योजना
                </div>

                <div className="scheme-card-desc">
                  पारंपरिक जलस्रोतांचे संवर्धन
                  व पुनरुज्जीवन करणे.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  योजना विस्तारीकरण
                </div>

                <div className="scheme-card-desc">
                  अस्तित्वातील पाणीपुरवठा
                  योजनांचा विस्तार व बळकटीकरण.
                </div>
              </div>

            </div>

          </section>

          {/* JJM */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💧
              </div>

              <h2 className="dept-section-title">
                जल जीवन मिशन (JJM)
              </h2>

            </div>

            <div className="dept-highlight-box">

              <div className="dept-highlight-box-title">
                🚿 हर घर जल अभियान
              </div>

              <p>
                जल जीवन मिशन हा भारत सरकारचा
                महत्त्वपूर्ण उपक्रम असून प्रत्येक ग्रामीण
                घराला कार्यक्षम नळ जल जोडणी (FHTC)
                उपलब्ध करून सुरक्षित व पुरेसा पिण्याचा
                पाणीपुरवठा सुनिश्चित करणे हा उद्देश आहे.
              </p>

            </div>

            <div
              className="dept-services-grid"
              style={{ marginTop: "18px" }}
            >

              <div className="dept-service-item">
                100% नळ जलपुरवठा
              </div>

              <div className="dept-service-item">
                सुरक्षित पिण्याचे पाणी
              </div>

              <div className="dept-service-item">
                पाणी गुणवत्ता तपासणी
              </div>

              <div className="dept-service-item">
                समुदाय सहभाग
              </div>

              <div className="dept-service-item">
                जलस्रोत संवर्धन
              </div>

              <div className="dept-service-item">
                सांडपाणी व्यवस्थापन
              </div>

            </div>

          </section>

          {/* FEATURES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                ⚙️
              </div>

              <h2 className="dept-section-title">
                जल जीवन मिशनची वैशिष्ट्ये
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  विकेंद्रित दृष्टीकोन
                </div>

                <div className="scheme-card-desc">
                  ग्रामस्तरीय संस्थांना योजना तयार करणे,
                  अंमलबजावणी व व्यवस्थापनाची जबाबदारी.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आधुनिक तंत्रज्ञानाचा वापर
                </div>

                <div className="scheme-card-desc">
                  IoT आधारित सेन्सर, जिओ-टॅगिंग
                  व स्मार्ट जलपुरवठा निरीक्षण.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  जलस्रोत व्यवस्थापन
                </div>

                <div className="scheme-card-desc">
                  पावसाचे पाणी संकलन, भूजल पुनर्भरण
                  व जलसंपत्ती संवर्धन उपक्रम.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  जनजागृती मोहीम
                </div>

                <div className="scheme-card-desc">
                  पाणी संवर्धन व योग्य वापरासाठी
                  समुदाय आधारित अभियान.
                </div>

              </div>

            </div>

          </section>

          {/* FUNDING */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💰
              </div>

              <h2 className="dept-section-title">
                अर्थसहाय्य पद्धती
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  सामान्य राज्ये
                </div>

                <div className="scheme-card-desc">
                  50:50 केंद्र व राज्य सरकार
                  खर्च विभागणी.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  हिमालयीन व ईशान्य राज्ये
                </div>

                <div className="scheme-card-desc">
                  90:10 केंद्र व राज्य सरकार
                  खर्च विभागणी.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  केंद्रशासित प्रदेश
                </div>

                <div className="scheme-card-desc">
                  100% निधी केंद्र सरकारमार्फत.
                </div>

              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                प्रमुख योजना
              </div>

              <div className="dept-info-val">
                जल जीवन मिशन
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                पाणी उद्दिष्ट
              </div>

              <div className="dept-info-val">
                55 LPCD
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                निधी पद्धती
              </div>

              <div className="dept-info-val">
                50:50
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                घरगुती जोडणी
              </div>

              <div className="dept-info-val">
                FHTC
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>020-26134806</span>
            </div>

            <div className="dept-contact-row">
              <span>📍</span>
              <span>जिल्हास्तरीय कार्यालये</span>
            </div>

            <div className="dept-contact-row">
              <span>👨‍💼</span>
              <span>
                उप अभियंता व गट विकास अधिकारी
              </span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                नळ जल जोडणी
              </div>

              <div className="dept-service-item">
                विहीर योजना
              </div>

              <div className="dept-service-item">
                हातपंप सेवा
              </div>

              <div className="dept-service-item">
                जल गुणवत्ता तपासणी
              </div>

              <div className="dept-service-item">
                पाणी संवर्धन
              </div>

              <div className="dept-service-item">
                सांडपाणी व्यवस्थापन
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>ग्रामीण पाणी पुरवठा बांधकाम विभाग</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default GraminPaniPuravathaVibhag;